import styled from 'styled-components';

export const StylesPreWrapper = styled.div`
    white-space: inherit;
    line-height: 1.5;
    text-align: left;
    font-size: 18px;
    box-sizing: border-box;
    margin: 1.5;
`;
